import React from 'react';
import AudioPlayer from './AudioPlayer';
import assisstantStyles from "./Assistant/assistant.module.css";
import Arrow from "../../../assets/ai-tutor/arrow.svg";
import AssistantImg from "../../../assets/ai-tutor/assistant.svg";
import pkg from "@inrscr/coschool-ui-components";
import { useAudio } from '../../../context/AudioContext';
import { renderTextHighlight } from '../../../utils/TutorConstants';

export default function DoubtKeyTakeAway(props) {
  const { TutorSummary } = pkg;
  const { index, summary, assistantRefImages, isSummaryCompleted, chatId, chatIndex } = props;
  const { hilightedText, playingIndex: currentAudioIndex } = useAudio();
  return (
    <TutorSummary
      summaryTitle={"Key Takeaway"}
      summary={renderTextHighlight(index, currentAudioIndex, summary, hilightedText)}
      icons={{
        Arrow,
        Assistant: AssistantImg
      }}
      styles={assisstantStyles}
      assistantRefImages={assistantRefImages || []}
      isDoubt={true}
      audioPlayer={
      window?.ENV?.ENABLE_VOICE == "true" && isSummaryCompleted ?
      () => <AudioPlayer text={summary} index={index} chatID={chatId} chatIndex={chatIndex} /> :
      undefined
      } />);


}